import { useTranslation } from 'react-i18next'
import { SansText } from '@velasca/ui/sans-text'
import { DutiesDisclaimerPopover } from './DutiesDisclaimer.styles'

export const DutiesDisclaimer = (): JSX.Element => {
  const { t } = useTranslation('global')

  return (
    <SansText as="div" size="sm">
      {t('cart_label_duties')}
      <DutiesDisclaimerPopover message={t('cart_label_duties_tooltip')}>
        <SansText as="span" color="primary" size="sm" cursor="pointer">
          {t('cart_label_duties_button')}
        </SansText>
      </DutiesDisclaimerPopover>
    </SansText>
  )
}
